module.exports = __webpack_public_path__ + "img/UTEAST-8.da33676a.jpg";